import axios from 'axios';

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Dynamic base URL for development and production live environment
export const API_BASE_URL = isLocal
  ? (import.meta.env.VITE_API_URL || 'http://localhost:5000/api')
  : (import.meta.env.VITE_API_URL && !import.meta.env.VITE_API_URL.includes('localhost')
      ? import.meta.env.VITE_API_URL
      : `${window.location.origin}/api`);


export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to attach the auth token
apiClient.interceptors.request.use(
  (config) => {
    // Attempt to get the token from localStorage
    const storedUser = localStorage.getItem('hrms_user');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        // Assuming your backend expects a Bearer token and your user object contains a 'token' field
        if (user && user.token) {
          config.headers.Authorization = `Bearer ${user.token}`;
        }
      } catch (error) {
        console.error('Failed to parse user from local storage', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle global errors (like 401 Unauthorized)
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Check if this is a login request to avoid infinite reload loop/refresh on login failure
      const isLoginRequest = error.config && error.config.url && error.config.url.includes('login');
      if (!isLoginRequest) {
        localStorage.removeItem('hrms_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);
